import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ProductionPlanningCalendarComponent
} from './view/production-planning-calendar/production-planning-calendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { TooltipModule } from 'primeng/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import {
  ActivityCalendarComponent
} from './view/production-planning-calendar/activity-calendar/activity-calendar.component';
import { MiscModule } from '../../../../../core/src/lib/misc/misc.module';
import { ACCalendarModule } from '../../../../../desktop/src/app/modules/full-calendar/ac-calendar.module';
import {
  ActivityCalendarFilterComponent
} from './view/production-planning-calendar/activity-calendar-filter/activity-calendar-filter.component';
import { CheckboxModule } from 'primeng/checkbox';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ActivityEngineeringComponent } from './view/production-planning-calendar/activity-engineering/activity-engineering.component';
import { EngineeringColumnComponent } from './view/production-planning-calendar/activity-engineering/engineering-column/engineering-column.component';
import { EngineeringTileComponent } from './view/production-planning-calendar/activity-engineering/engineering-column/engineering-tile/engineering-tile.component';
import {RouterModule} from '@angular/router';

@NgModule({
  declarations: [
    ProductionPlanningCalendarComponent,
    ActivityCalendarComponent,
    ActivityCalendarFilterComponent,
    ActivityEngineeringComponent,
    EngineeringColumnComponent,
    EngineeringTileComponent,
  ],
    imports: [
        CommonModule,
        FullCalendarModule,
        TooltipModule,
        MatDialogModule,
        MatRippleModule,
        MatIconModule,
        MatButtonModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule,
        MatProgressSpinnerModule,
        OverlayPanelModule,
        MiscModule,
        ACCalendarModule,
        CheckboxModule,
        FormsModule,
        DragDropModule,
        RouterModule
    ],
  exports: []

})
export class ProductionPlanningModule {
}
